<template>
  <keep-alive include="keepOrderWater">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "OrderWater"
};
</script>
